import React from 'react';
import { Link } from 'react-router-dom';
import './StaticPages.css';

const PLAN_FEATURES = [
  '✅ Lifetime Access — Pay once, use forever',
  '✅ Create your complete matrimony profile',
  '✅ Browse all compatible profiles (horoscope filtered)',
  '✅ Horoscope match score for every profile',
  '✅ 27 Nakshatra compatibility analysis',
  '✅ Shortlist & save favorite profiles',
  '✅ Contact request system (privacy protected)',
  '✅ View who viewed your profile',
  '✅ Receive contact requests from others',
  '✅ Admin verified badge on your profile',
  '✅ Profile visibility control',
  '✅ Notification alerts',
  '✅ Photo upload (9:16 portrait)',
  '✅ Birth horoscope upload',
  '✅ English + Tamil profile display',
];

export default function Plan() {
  return (
    <div className="static-page">
      <div className="page-header">
        <h1>Plan & Pricing</h1>
        <p>Simple, transparent one-time pricing</p>
      </div>

      <div className="container static-content">
        <div className="plan-page-wrap">
          {/* Plan Card */}
          <div className="plan-card-big">
            <div className="plan-badge-wrap">
              <span className="plan-popular">🌟 Most Popular</span>
            </div>
            <div className="plan-header-section">
              <h2>Lifetime Membership</h2>
              <p className="plan-tamil">வாழ்நாள் உறுப்பினர் திட்டம்</p>
              <div className="plan-price-big">
                <span className="price-currency">₹</span>
                <span className="price-amount">499</span>
                <span className="price-term">/ Lifetime</span>
              </div>
              <p className="plan-note">One-time payment. No monthly charges. No hidden fees.</p>
              <Link to="/register" className="btn btn-gold btn-lg" style={{width:'100%',justifyContent:'center',marginTop:'8px'}}>
                🪷 Register & Get Started
              </Link>
            </div>
            <div className="plan-features-list">
              <h3>Everything Included:</h3>
              {PLAN_FEATURES.map(f => <div key={f} className="plan-feature-item">{f}</div>)}
            </div>
          </div>

          {/* Payment Info */}
          <div className="payment-info-card card" style={{padding:'32px'}}>
            <h2>💳 Payment Process</h2>
            <div className="payment-steps">
              {[
                { n: '1', t: 'Register', d: 'Fill your complete profile details (26 fields)' },
                { n: '2', t: 'Pay ₹499', d: 'Scan QR code or use UPI ID: kubendiransys-1@oksbi' },
                { n: '3', t: 'Enter Transaction ID', d: 'Paste your UPI transaction ID after payment' },
                { n: '4', t: 'Admin Verifies', d: 'Admin verifies your payment within 24 hours' },
                { n: '5', t: 'Profile Approved!', d: 'Start browsing compatible profiles' },
              ].map(s => (
                <div key={s.n} className="pay-step">
                  <div className="pay-step-num">{s.n}</div>
                  <div>
                    <strong>{s.t}</strong>
                    <p>{s.d}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="upi-box">
              <h3>UPI Payment Details</h3>
              <div className="upi-detail">
                <span>UPI ID:</span>
                <strong>kubendiransys-1@oksbi</strong>
              </div>
              <div className="upi-detail">
                <span>Amount:</span>
                <strong>₹499 (One Time)</strong>
              </div>
              <div className="upi-detail">
                <span>Payment to:</span>
                <strong>Suvaran Maran Matrimony</strong>
              </div>
            </div>

            <div className="refund-note">
              <h4>⚠️ Refund Policy</h4>
              <p>All payments are non-refundable. Please review your profile carefully before making payment. For any issues, contact our support team.</p>
            </div>
          </div>
        </div>

        {/* FAQ */}
        <div className="faq-section">
          <h2 className="section-title text-center">Frequently Asked Questions</h2>
          <div className="gold-divider" />
          <div className="faq-grid">
            {[
              { q: 'Can I create multiple profiles?', a: 'No. Only one profile per phone number is allowed. This ensures authenticity and prevents duplicate profiles.' },
              { q: 'How long does approval take?', a: 'Admin verifies payments and approves profiles within 24 hours on business days.' },
              { q: 'How are profiles filtered?', a: 'Profiles are automatically filtered by horoscope type. Sutham members only see Sutham profiles, Seva sees Seva, etc.' },
              { q: 'How does contact request work?', a: 'You send a contact request. The other person must approve it. Only then will their phone number be shown to you.' },
              { q: 'Can I edit my profile after submitting?', a: 'Yes, you can edit your profile anytime from your dashboard. Admin may also fix any mistakes on your behalf.' },
              { q: 'Is the ₹499 refundable?', a: 'No, all payments are non-refundable. Please read our refund policy before making payment.' },
            ].map(f => (
              <div key={f.q} className="faq-item">
                <h4>Q: {f.q}</h4>
                <p>A: {f.a}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
